
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/companies",
      function () {
        return require("private-next-pages/next/companies/index.tsx");
      }
    ]);
  